const isMobile = /(ios|android)/i.test(document.userPlatform);

export default isMobile;
